export const ErrorMessage = (error:string|undefined) => {
  return (
    <small
      style={{
        color: "red",
        fontSize: "10px",
        maxWidth: "200px",
        display: "flex",
      }}
    >
      {error}
    </small>
  );
};
